import { useState } from "react";
import axiosInstance from "../../axios/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { Label } from "../../components/reusableComponents/Label";
import { Input } from "../../components/reusableComponents/Input";
import {
  Select,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectContent,
} from "../../components/reusableComponents/Select";
import { message } from "antd";
import { Button } from "../../components/reusableComponents/Button";
import { Loader2 } from "lucide-react";

export default function ClientForm({ setClients, clients, close }) {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    siret: "",
    denomination: "",
    pld: "",
    ape: "",
    TVA: "",
    tvaRate: "",
    address: "",
    postCode: "",
    town: "",
    addressLivraison: "",
    postCodeLivraison: "",
    townLivraison: "",
    addressFacturation: "",
    postCodeFacturation: "",
    townFacturation: "",
    contactFirstname: "",
    contactLastname: "",
    contactEMail: "",
    contactPhone: "",
    facturation: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const paymentConditions = [
    "À Réception",
    "À 10 jours",
    "À 15 jours",
    "Fin de mois",
    "30 jours date de facture",
    "30 jours fdm",
    "À 45 jours",
    "60 jours fdm",
  ];

  const tvaOptions = [
    "TVA 20%",
    "TVA 10%",
    "TVA 5.5%",
    "TVA 0% UE",
    "TVA 0% HORS UE",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const copyAddressTo = (target) => {
    setForm({
      ...form,
      [`address${target}`]: form.address,
      [`postCode${target}`]: form.postCode,
      [`town${target}`]: form.town,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "siret",
      "denomination",
      "ape",
      "TVA",
      "address",
      "postCode",
      "town",
      "addressLivraison",
      "postCodeLivraison",
      "townLivraison",
      "addressFacturation",
      "postCodeFacturation",
      "townFacturation",
      "contactFirstname",
      "contactLastname",
      "contactEMail",
      "contactPhone",
      "facturation",
      "tvaRate",
    ];

    const emptyField = requiredFields.find((f) => !form[f]?.trim());
    console.log(emptyField);
    if (emptyField) {
      alert("Tous les champs sont obligatoires");
      return;
    }
    setIsLoading(true);

    try {
      const res = await axiosInstance.post("client", {
        ...form,
        companyName: form.denomination,
        contacts: [
          {
            firstname: form.contactFirstname,
            lastname: form.contactLastname,
            email: form.contactEMail,
            mobile: form.contactPhone.replace(/\s/g, ""),
          },
        ],
      });

      setClients([...clients, res.data]);
      message.success("Client créé");
      close();
    } catch (e) {
      console.log(e);
      if (e.response?.data?.statusCode === 403) {
        localStorage.clear();
        navigate("/login");
      } else if (e.response?.data?.statusCode === 409) {
        message.error("Le client existe déjà !");
      } else {
        message.error("Erreur lors de la création du client");
      }
    }
    setIsLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 p-4">
      {/* Informations Société */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="siret">SIRET</Label>
          <Input
            name="siret"
            placeholder="123 456 789 00000"
            value={form.siret}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="denomination">Raison Sociale</Label>
          <Input
            name="denomination"
            placeholder="Nom de l'entreprise"
            value={form.denomination}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="pld">Numéro PLD</Label>
          <Input
            name="pld"
            placeholder="Numéro PLD"
            value={form.pld}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="ape">Code APE</Label>
          <Input
            name="ape"
            placeholder="APE 1234Z"
            value={form.ape}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="TVA">TVA Intra</Label>
          <Input
            name="TVA"
            placeholder="FR12345678901"
            value={form.TVA}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* Adresse siège sur toute la largeur */}
      <div className="space-y-2 pt-2">
        <Label htmlFor="address">Adresse Siège</Label>
        <Input
          name="address"
          placeholder="10 Rue Exemple"
          value={form.address}
          onChange={handleChange}
        />
      </div>

      {/* Code postal + ville */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="postCode">Code Postal</Label>
          <Input
            name="postCode"
            placeholder="75000"
            value={form.postCode}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="town">Ville</Label>
          <Input
            name="town"
            placeholder="Paris"
            value={form.town}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="flex  items-center justify-between">
        <div className="w-1/2 flex justify-center">
          <Button type="button" onClick={() => copyAddressTo("Livraison")}>
            Copier vers Livraison
          </Button>
        </div>
        <div className="w-1/2 flex justify-center">
          <Button type="button" onClick={() => copyAddressTo("Facturation")}>
            Copier vers Facturation
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Adresse Livraison</Label>
          <Input
            name="addressLivraison"
            placeholder="Adresse"
            value={form.addressLivraison}
            onChange={handleChange}
          />
          <Input
            name="postCodeLivraison"
            placeholder="Code postal"
            value={form.postCodeLivraison}
            onChange={handleChange}
          />
          <Input
            name="townLivraison"
            placeholder="Ville"
            value={form.townLivraison}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label>Adresse Facturation</Label>
          <Input
            name="addressFacturation"
            placeholder="Adresse"
            value={form.addressFacturation}
            onChange={handleChange}
          />
          <Input
            name="postCodeFacturation"
            placeholder="Code postal"
            value={form.postCodeFacturation}
            onChange={handleChange}
          />
          <Input
            name="townFacturation"
            placeholder="Ville"
            value={form.townFacturation}
            onChange={handleChange}
          />
        </div>
      </div>
      <div>
        <Label className="space-y-4">Contact principal</Label>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Nom</Label>
          <Input
            name="contactLastname"
            placeholder="Dupont"
            value={form.contactLastname}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label>Prénom</Label>
          <Input
            name="contactFirstname"
            placeholder="Jean"
            value={form.contactFirstname}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label>Email</Label>
          <Input
            name="contactEMail"
            type="email"
            placeholder="jean.dupont@email.com"
            value={form.contactEMail}
            onChange={handleChange}
          />
        </div>
        <div className="space-y-2">
          <Label>Téléphone</Label>
          <Input
            name="contactPhone"
            placeholder="0612345678"
            value={form.contactPhone}
            onChange={handleChange}
          />
        </div>
      </div>

      <div>
        <div className="space-y-2">
          <Label>Provenance</Label>
          <Select
            onValueChange={(val) =>
              setForm({ ...form, clientAcquisition: val })
            }
          >
            <SelectTrigger>
              <SelectValue placeholder="Sélectionner..." />
            </SelectTrigger>
            <SelectContent className="bg-white">
              {[
                "Téléprospection",
                "Visite clientèle",
                "Réseaux sociaux",
                "Prise de reférence",
                "Contrat cadre",
                "Autre",
              ].map((cond) => (
                <SelectItem key={cond} value={cond}>
                  {cond}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>Condition de paiement</Label>
          <Select
            onValueChange={(val) => setForm({ ...form, facturation: val })}
          >
            <SelectTrigger>
              <SelectValue placeholder="Sélectionner..." />
            </SelectTrigger>
            <SelectContent className="bg-white">
              {paymentConditions.map((cond) => (
                <SelectItem key={cond} value={cond}>
                  {cond}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label>TVA</Label>
          <Select onValueChange={(val) => setForm({ ...form, tvaRate: val })}>
            <SelectTrigger>
              <SelectValue placeholder="Sélectionner..." />
            </SelectTrigger>
            <SelectContent className="bg-white">
              {tvaOptions.map((rate) => (
                <SelectItem key={rate} value={rate}>
                  {rate}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="pt-4 flex justify-end gap-4">
        <Button
          type="submit"
          className="bg-indigo-600 text-white hover:bg-indigo-700"
        >
          {!isLoading && <span>Créer le client</span>}
          {isLoading && (
            <span>
              <Loader2 className="w-5 h-5 text-white" />
            </span>
          )}
        </Button>
      </div>
    </form>
  );
}
